import React, { useState, useEffect, useCallback } from "react";
import "./i18n";
import Header from "./components/Header";
import Home from "./components/Home";
import StatsCards from "./components/StatsCards";
import TemperatureChart from "./components/TemperatureChart";
import UnitToggle from "./components/UnitToggle";
import { Box, Typography, LinearProgress } from "@mui/material";
import Seo from "./Seo";
export default function App() {

  const [unit, setUnit] = useState("C");
  const [rawData, setRawData] = useState([]);
  const [date, setRawDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cookie helper
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  const token = getCookie("AccessToken");
  const isLoggedIn = !!token;

  // Fetch API
  const fetchTemperature = useCallback(async () => {
    try {
      setLoading(true);

      const url = `https://mastertechnologis.com/api/v3_2/rtdashgata/?u=c&t=${token}`;
      const res = await fetch(url);

      if (!res.ok) {
        throw new Error("API Error");
      }

      const data = await res.json();

      setRawData(data?.data || []);
      setRawDate(data?.date || "");
      setError(null);
    } catch (err) {
      console.error("Fetch error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  // Run only if logged in
  useEffect(() => {
    if (!isLoggedIn) return;

    fetchTemperature();

    const interval = setInterval(() => {
      fetchTemperature();
    }, 900000); // 15 min

    return () => clearInterval(interval);
  }, [fetchTemperature, isLoggedIn]);

  // const { t, i18n } = useTranslation();

  // useEffect(() => {
  //   document.title = t("pageTitle");
  //   const meta = document.getElementById("meta-description");
  //   if (meta) {
  //     meta.setAttribute("content", t("metaDescription"));
  //   }
  // }, [i18n.language, t]);

  // 👉 NOT logged in → show Home page
  return (
    <>
      <Seo />

      {!isLoggedIn ? (
        <Home />
      ) : loading ? (
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Header />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Loading temperature...
          </Typography>
          <LinearProgress sx={{ mt: 2 }} />
        </Box>
      ) : error ? (
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Header />
          <Typography color="error" sx={{ mt: 2 }}>
            Failed to load data. Please try again.
          </Typography>
        </Box>
      ) : (
        <div>
          <Header />
          <UnitToggle unit={unit} setUnit={setUnit} />
          <TemperatureChart rawData={rawData} unit={unit} date={date} />
          <StatsCards rawData={rawData} unit={unit} />
        </div>
      )}
    </>
  );
}
